module.exports = __webpack_public_path__ + "static/media/social-icons.75a2e24c.png";